import { render, staticRenderFns } from "./client-setup-form.vue?vue&type=template&id=4f503a29&scoped=true&"
import script from "./client-setup-form.vue?vue&type=script&lang=ts&"
export * from "./client-setup-form.vue?vue&type=script&lang=ts&"
import style0 from "./client-setup-form.vue?vue&type=style&index=0&id=4f503a29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f503a29",
  null
  
)

export default component.exports